export type ModularBenefitAudience = 'employee' | 'ecc';

export interface AudienceHiddenComponent {
  hideForEmployee?: boolean;
  hideForEcc?: boolean;
}

export function isComponentHiddenForAudience(
  component: AudienceHiddenComponent,
  audience: ModularBenefitAudience
): boolean {
  return audience === 'ecc'
    ? !!component.hideForEcc
    : !!component.hideForEmployee;
}

export function isComponentVisibleForAudience(
  component: AudienceHiddenComponent,
  audience: ModularBenefitAudience
): boolean {
  return !isComponentHiddenForAudience(component, audience);
}
